export default "__VITE_ASSET__Dhqye_ps__"